const english = {
  file: "File",
  workspace: "Personal workspace",
  untitled: "Untitled canvas",
  export: "Export",
  styles: "Style & arrange",
  tools: "Drawing tools",
  more: "More tools",
  local: "Stored on this device",
  welcomeTitle: "Give your ideas a little space.",
  welcomeBody:
    "Sketch a thought, connect the dots, or make something entirely new.",
  welcomeHint: "Pick a tool to begin. Your canvas stays in this browser.",
  open: "Open a drawing",
  help: "Quick guide",
  hub: "Explore OpusDesk Hub",
  files: "YOUR CANVAS",
  preferences: "WORKSPACE SETTINGS",
  shortcuts: "TOOLS & SHORTCUTS",
  create: "CREATE",
};
const traditional: typeof english = {
  file: "檔案",
  workspace: "個人工作區",
  untitled: "未命名畫布",
  export: "匯出",
  styles: "樣式與排列",
  tools: "繪圖工具",
  more: "更多工具",
  local: "本機儲存",
  welcomeTitle: "把想法，畫成形。",
  welcomeBody: "隨手記下一個靈感，串起思路，或從空白開始創作。",
  welcomeHint: "選一個工具就能開始。畫布會保存在這個瀏覽器。",
  open: "開啟作品",
  help: "使用說明",
  hub: "探索 OpusDesk Hub",
  files: "你的畫布",
  preferences: "工作區設定",
  shortcuts: "工具與快捷鍵",
  create: "建立",
};
const simplified: typeof english = {
  ...traditional,
  file: "文件",
  workspace: "个人工作区",
  untitled: "未命名画布",
  export: "导出",
  styles: "样式与排列",
  tools: "绘图工具",
  more: "更多工具",
  local: "本地存储",
  welcomeTitle: "把想法，画成形。",
  welcomeBody: "随手记下一个灵感，串起思路，或从空白开始创作。",
  welcomeHint: "选一个工具就能开始。画布会保存在这个浏览器。",
  open: "打开作品",
  help: "使用说明",
  hub: "探索 OpusDesk Hub",
  files: "你的画布",
  preferences: "工作区设置",
  shortcuts: "工具与快捷键",
};
export const workspaceText = (langCode: string, key: keyof typeof english) =>
  (langCode === "zh-TW"
    ? traditional
    : langCode.startsWith("zh")
    ? simplified
    : english)[key];
